import React, { useState } from 'react';
import { experience, sectionExpTitle } from '../../profile';

const ExperienceItem = ({ job }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="tl-item">
            <div className="tl-dot"></div>
            <div className="tl-role">{job.role}</div>
            <div className="tl-company">{job.company}, {job.location}</div>
            <div className="tl-date">{job.period}</div>
            {job.bullets && job.bullets.length > 0 && (
                <>
                    <button
                        className="tl-toggle"
                        onClick={() => setOpen(o => !o)}
                        aria-expanded={open}
                    >
                        {open ? '▲ Hide details' : '▼ Show details'}
                    </button>
                    {open && (
                        <ul className="tl-bullets">
                            {job.bullets.map((b, j) => (
                                <li key={j}>{b}</li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </div>
    );
};

const Experience = () => {
    return (
        <div data-aos="zoom-in-up" data-aos-once="true" className="experience-section">
            <div className="exp-section-head">
                <h1 className="red-line pp-head">{sectionExpTitle}</h1>
            </div>
            <div className="timeline">
                {experience.map((job, i) => (
                    <ExperienceItem key={i} job={job} />
                ))}
            </div>
        </div>
    );
};

export default Experience;
